import {createSlice} from "@reduxjs/toolkit";

const coursesResponseUrl = createSlice({
    name: 'coursesResponseUrl',
    initialState: {
        redirectUrl: '',
        success: '',
        trackingId: '',
    },
    reducers: {
        setRedirectUrlTrackingId: (state, action) => {
            const { success, trackingId, redirectUrl } = action.payload;
            state.redirectUrl = redirectUrl;
            state.success = success;
            state.trackingId = trackingId;
        },
    },
});

export const { setRedirectUrlTrackingId } = coursesResponseUrl.actions;

export const coursesResponseUrlReducer = coursesResponseUrl.reducer;

